import { getLatesUnepCertificateThunkAction } from "./getLatesUnepCertificate.thunk.action";

import $api from "../../../../../services/axiosService";

export const confirmUnepPhoneChangeThunkAction = (issueId, code, props) => async (dispatch) => {
    try {
        props.setLoader(true);
        await $api.post(`v1/c/certificates/issues/${issueId}/phone-change/confirm`, { code });
        props.setLoader(false);
        props.setPhoneVerifyVisible(false);
        dispatch(getLatesUnepCertificateThunkAction());
    } catch (e) {
        props.setLoader(false);
        props.setAuthNumber(e?.response?.data?.detail || "Неверный код. Попробуйте ещё раз.");
    }
};